'use strict';

angular.module('buyers')
.directive('financeSolution', ['$location', '$rootScope', 'BuyerService', function($location, $rootScope, BuyerService) {
    return {
        templateUrl : "partials/finance-solution.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'property':'='
        },
        link : function (scope, element, attrs) {


            var addFinanceClickNote  = function(property) {
                $rootScope.loading = true;
                var propertyAddress = property.streetUnit + ' '  + property.streetRef + ' ' + property.streetName + ' ' + property.streetType; 
                var noteText = "Buyer clicked finance option for the property: " + propertyAddress;
                BuyerService.addNote(noteText)
                .then(function(data){
                    $rootScope.loading = false;
                })
                .catch(function(err){
                    console.log(err);
                })
                .finally(function(data){
                    $rootScope.loading = false;
                });
            }

            // var loanAmount = (parseInt(scope.property.valuationFrom) + parseInt(scope.property.valuationTo)) / 2;
            
            scope.financeInfo = {};
            var init = function() {
                addFinanceClickNote(scope.property);
                $rootScope.loading = true;
                BuyerService.getFinanceInfo()
                .then(function(data){
                    var financeInfo = data.config.financeInfo;
                    scope.financeInfo = {
                        interestRatePercentage: parseFloat(financeInfo.interestRatePercentage),
                        interestRate: (parseFloat(financeInfo.interestRatePercentage)/100),
                        term: parseInt(financeInfo.term),
                        frequency: parseInt(financeInfo.frequency),
                        date: financeInfo.date,
                        repaymentAmount: 0,
                    }
                    $rootScope.loading = false;
                })
                .catch(function(err){
                    console.log(err);
                    $rootScope.loading = false;
                })
                .finally(function(data){
                    $rootScope.loading = false;
                });
            };

            init();
             
            var fnCalculateRepayment = function(loanAmount) {
                loanAmount = parseInt(loanAmount);
                var financeInfo = scope.financeInfo;
                scope.financeInfo.repaymentAmount = Math.round((loanAmount + (loanAmount * financeInfo.interestRate))/(financeInfo.term * financeInfo.frequency));
            }
            

            scope.financeApplication = function() {
                var previousPage = $location.path();
                $location.path('/finance-application/').search({ propertyRef: scope.property.propertyRef, previousPage: previousPage });
            }

            scope.fnShowDisclaimer = function() {
                scope.showDisclaimer = true;
            }

            element.find('#loan-amount').on('keyup', function() {
                loanAmount = $(this).val();
                scope.$apply(function(){
                    fnCalculateRepayment(loanAmount);
                });
                
            });
        }
    };
}]);